import { Check, Unlink } from "lucide-react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { Checkbox } from "../ui/checkbox";

export function GoogleSettingsDialog({
  open,
  onOpenChange,
  googleEmail,
  calendars,
  onToggleCalendarSync,
  onDisconnect,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white font-['Outfit']">
            Google Calendar Settings
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Connected as {googleEmail}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <h3 className="text-sm font-medium text-slate-300 mb-3">
              Select calendars to sync
            </h3>
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {calendars.map((cal) => (
                <div
                  key={cal.id}
                  className="flex items-center gap-3 p-3 rounded-lg bg-slate-800/50 hover:bg-slate-800 transition-colors cursor-pointer"
                  onClick={() => onToggleCalendarSync(cal.id, cal.synced)}
                  data-testid={`calendar-toggle-${cal.id}`}
                >
                  <Checkbox
                    checked={cal.synced}
                    onCheckedChange={() => onToggleCalendarSync(cal.id, cal.synced)}
                  />
                  <div
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: cal.color }}
                  />
                  <span className="text-white flex-1 truncate">
                    {cal.name}
                    {cal.primary && (
                      <span className="text-xs text-slate-500 ml-2">(Primary)</span>
                    )}
                  </span>
                  {cal.synced && <Check size={16} className="text-emerald-400" />}
                </div>
              ))}
            </div>
          </div>

          <div className="pt-4 border-t border-slate-800">
            <Button
              variant="outline"
              onClick={onDisconnect}
              className="w-full border-red-800 text-red-400 hover:bg-red-950"
              data-testid="disconnect-google"
            >
              <Unlink size={16} className="mr-2" />
              Disconnect Google Calendar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
